import React from "react";
import styled from "styled-components";
// import Checkbox from '@material-ui/core/Checkbox';
// import { RadioButton } from "material-ui/RadioButton";

const colPadding = "10px";
const Row = styled.div`
  display: flex;
  text-align: left;
  border-bottom: dotted 1px #eee;
`;
const Col1 = styled.div`
  display: flex;
`;
const Col2 = styled.div`
  text-align: left;
  padding: ${colPadding};
`;
const Col3 = styled.div`
  text-align: right;
  margin-left: auto;
  padding: ${colPadding};
`;
const RadioButton = styled.input`
  margin: auto;
  cursor: pointer;
`;

// const handleChange = name => event => {
//   this.setState({ [name]: event.target.checked });
// };

const LocationItem = ({
  tripType,
  radioButtonName,
  type,
  country_code,
  iata,
  city,
  locationId,
  locationIdType,
  airport,
  handleRadioClick
}) => (
  <div>
    <Row>
      <Col1>
        <RadioButton
          type="radio"
          id={locationId}
          name={radioButtonName}
          // checked={true}
          onChange={handleRadioClick({ locationId, locationIdType, tripType })}
        />
      </Col1>
      <Col2>
        <div>{airport ? airport : city}</div>
        <div>
          {city}, {country_code}
        </div>
      </Col2>
      <Col3>
        <div>{airport ? iata : "City"}</div>
        <div>{airport && "Airport"}</div>
      </Col3>
    </Row>
  </div>
);

export default LocationItem;



// WEBPACK FOOTER //
// ./src/scenes/LocationSuggestionsPage/components/LocationItem/index.js